import { type CSSToken, token } from '@atlaskit/tokens';

// skill border/accent colors that map to a color enum defined in integration service
// TODO: update with link when available in the backend
// TODO: move to a skills types/integration service package
export type SkillColor =
	| 'lime'
	| 'red'
	| 'orange'
	| 'yellow'
	| 'green'
	| 'teal'
	| 'blue'
	| 'purple'
	| 'magenta'
	| 'gray'
	| 'default';

type SkillColorMap = Record<SkillColor, { default: CSSToken; inverse?: CSSToken }>;

// mapping of skill color enum to ADS color tokens. Use inverse colors for dark backgrounds
export const SKILL_COLOR_MAP: SkillColorMap = {
	lime: {
		default: token('color.border.accent.lime'),
	},
	red: {
		default: token('color.border.accent.red'),
	},
	orange: {
		default: token('color.border.accent.orange'),
	},
	yellow: {
		default: token('color.border.accent.yellow'),
	},
	green: {
		default: token('color.border.accent.green'),
	},
	teal: {
		default: token('color.border.accent.teal'),
	},
	blue: {
		default: token('color.border.accent.blue'),
	},
	purple: {
		default: token('color.border.accent.purple'),
	},
	magenta: {
		default: token('color.border.accent.magenta'),
	},
	gray: {
		default: token('color.border.accent.gray'),
	},
	default: {
		default: token('color.border'),
		inverse: token('color.border.inverse'),
	},
};
